"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var MediaQueryListener = /*#__PURE__*/function () {
  function MediaQueryListener(eventListener) {
    _classCallCheck(this, MediaQueryListener);

    this.debounce = 66;
    this.timeout = false;
    this.eventListener = eventListener;
    this.breakPointMap = {
      mobile: {
        display: 'mobile',
        value: 0
      },
      tablet: {
        display: 'tablet',
        value: 1
      },
      desktop: {
        display: 'desktop',
        value: 2
      },
      'xl-display': {
        display: 'xl-display',
        value: 3
      }
    };
    this.atMinWidth = this.atMinWidth.bind(this);
    this.atMaxWidth = this.atMaxWidth.bind(this);
    this.getBreakPoint = this.getBreakPoint.bind(this);
    this.emitResizeEvent = this.emitResizeEvent.bind(this);
    this.init();
  }

  _createClass(MediaQueryListener, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.setResizeEvent();
      setTimeout(function () {
        _this.breakPoint = _this.getBreakPoint();

        if (_this.breakPoint) {
          _this.setResizeEventListener();
        }
      }, this.debounce);
    }
  }, {
    key: "getBreakPoint",
    value: function getBreakPoint() {
      var breakPoint = window.getComputedStyle(document.body, ':before').content.replace(/"/g, '');
      return this.breakPointMap[breakPoint];
    }
  }, {
    key: "atMaxWidth",
    value: function atMaxWidth(view) {
      if (this.breakPoint) {
        var value = this.breakPoint.value;
        var threshold = this.breakPointMap[view];

        if (threshold && threshold.display) {
          return value <= threshold.value;
        }
      }

      return false;
    }
  }, {
    key: "atMinWidth",
    value: function atMinWidth(view) {
      if (this.breakPoint) {
        var value = this.breakPoint.value;
        var threshold = this.breakPointMap[view];

        if (threshold && threshold.display) {
          return value >= threshold.value;
        }
      }

      return false;
    }
  }, {
    key: "setResizeEventListener",
    value: function setResizeEventListener() {
      var _this2 = this;

      this.eventListener(this.breakPoint);
      window.addEventListener('windowResize', function (_ref) {
        var detail = _ref.detail;
        return _this2.eventListener(detail);
      });
    }
  }, {
    key: "setResizeEvent",
    value: function setResizeEvent() {
      var _this3 = this;

      if (!window.resizeEvent) {
        window.resizeEvent = function () {
          clearTimeout(_this3.timeout);
          _this3.timeout = setTimeout(_this3.emitResizeEvent, _this3.debounce);
        };

        window.addEventListener('resize', window.resizeEvent);
      }
    }
  }, {
    key: "emitResizeEvent",
    value: function emitResizeEvent() {
      var currentBreakPoint = this.getBreakPoint();

      if (currentBreakPoint.value !== this.breakPoint.value) {
        this.breakPoint = currentBreakPoint;
        window.dispatchEvent(new CustomEvent('windowResize', {
          detail: this.breakPoint
        }));
      }
    }
  }]);

  return MediaQueryListener;
}();

var _default = MediaQueryListener;
exports["default"] = _default;